import { useTranslation } from "react-i18next";

/* eslint-disable-next-line */
export interface WStoreAddressProps {
  title?: string;
  firstName?: string;
  lastName?: string;
  phone?: string | number | null;
  street?: string | null;
  streetNumber?: string | number | null;
  county?: string | null;
  city?: string | null;
  country?: string | null;
  blockNumber?: string | number | null;
  stairNumber?: string | number | null;
  apartmentNumber?: string | number | null;
  isCompany?: boolean | null;
  companyName?: string | null;
  companyRegNumber?: string | null;
  companyIdentificationNumber?: string | null;
  companyAddress?: string | null;
}

export function WStoreAddress(props: WStoreAddressProps) {
  const { t: tStore } = useTranslation("store");
  return (
    <div className="text-sm">
      <div className="font-bold">{props?.title && props?.title}</div>
      <div>
        {props.firstName &&
          props.lastName &&
          `${props.firstName} ${props.lastName}`}
      </div>
      <div>{props?.phone && `${tStore("phone")}: ${props?.phone}`}</div>
      {(props?.street ||
        props?.streetNumber ||
        props?.blockNumber ||
        props?.stairNumber ||
        props?.apartmentNumber ||
        props?.county ||
        props?.city) && (
        <div>{`${props?.street && `${tStore("street")}: ${props?.street}`}, ${
          props?.streetNumber && `${tStore("number")}: ${props?.streetNumber}`
        }, ${
          props?.blockNumber &&
          `${tStore("block-number")}: ${props?.blockNumber}`
        }, ${
          props?.stairNumber &&
          `${tStore("stair-number")}: ${props?.stairNumber}`
        } ${
          props?.apartmentNumber &&
          `${tStore("apartment")}: ${props?.apartmentNumber}`
        }, ${props.county && props.county + ","} ${
          props?.city && props?.city + ","
        } ${props?.country && props?.country}`}</div>
      )}
      {props?.companyName && (
        <div>
          <span className="font-bold">{tStore("company")}: </span>
          {`${props?.companyName}, ${
            props?.companyIdentificationNumber &&
            `${tStore("company-reg-number")}: ${
              props?.companyIdentificationNumber
            }`
          }, ${
            props?.companyIdentificationNumber &&
            `${tStore("company-cui")}: ${props?.companyIdentificationNumber}`
          }, ${
            props?.companyAddress &&
            `${tStore("company-address")}: ${props?.companyAddress}`
          }`}
        </div>
      )}
    </div>
  );
}

export default WStoreAddress;
